export class PassiveInvoiceUnknowError extends Error {
  constructor() {
    super("Errore sincronizzazione fatture passive sconosciuto");
  }
}
